import * as _ from 'lodash'
import {AffinitySetBO} from "./AffinitySetBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {WB_AffinityGroupItemRow, WB_AffinityGroupRow} from "../PA.Core/PAdbSchemaRows";

export class AffinitySetBOValidations {

    static ValidateOverlap(aBO: AffinitySetBO): Promise<void> {

        return new Promise<void>((resolve, error) => {
            let sError = ""
            let sTitle = ""
            let arrItems: WB_AffinityGroupItemRow[] = []

            _.forEach(_.filter(aBO.WB_AffinitySet.WB_AffinityGroupRows, aRow => aRow.cif.DELETED_IND != '1'), aRow => {
                arrItems = _.concat(arrItems, _.filter(aRow.WB_AffinityGroupItemRows, anItem => anItem.isActive))
            })

            let sortFields: string[] = []
            if (aBO.WB_AffinitySet.bItemHasCusotmer)
                sTitle = "Customer"

            if (aBO.WB_AffinitySet.bItemHasProduct) {
                sortFields = ['WB_CUST_ID', 'WB_PROD_ID', 'WB_AFFINITYGROUP_ID']
                if (!_.isEmpty(sTitle))
                    sTitle += '/'
                sTitle += "Product"
            }


            if (aBO.WB_AffinitySet.bItemHasProductGroup) {
                sortFields = ['WB_CUST_ID', 'WB_PRDGRP_ID', 'WB_AFFINITYGROUP_ID']
                if (!_.isEmpty(sTitle))
                    sTitle += '/'
                sTitle += "Product Group"
            }


            let custName = ''
            let prodName = ''
            let arrGroup: WB_AffinityGroupRow[] = []
            _.forEach(_.orderBy(arrItems, sortFields, ['asc', 'asc']), anItem => {
                let bCustomerChanged: boolean = aBO.WB_AffinitySet.bItemHasCusotmer && custName != (anItem.WB_CustomerRow.cif.CUSTOMER_NAME + '|' + anItem.WB_CustomerRow.cif.CUSTOMER_ID)
                let bProductChanged: boolean = false

                if (aBO.WB_AffinitySet.bItemHasProductGroup) {
                    if (prodName != (anItem.WB_ProductGroupRow.cif.PRODUCT_GROUP_NAME + '|' + anItem.WB_ProductGroupRow.cif.PRODUCT_GROUP_ID))
                        bProductChanged = true
                } else {
                    if (prodName != (anItem.WB_ProductRow.cif.PRODUCT_NAME + '|' + anItem.WB_ProductGroupRow.cif.PRODUCT_ID))
                        bProductChanged = true
                }


                if (bCustomerChanged || bProductChanged) {
                    if (arrGroup.length > 1) {
                        sError += (!_.isEmpty(custName) ? custName : '') + (!_.isEmpty(prodName) ? '-' : '') + (!_.isEmpty(prodName) ? prodName : '') + ' in Group ' + _.join(_.map(_.uniq(arrGroup), 'AFFINITYGROUP_NAME'), ",") + '\n'
                    }
                    custName = (aBO.WB_AffinitySet.bItemHasCusotmer) ? (anItem.WB_CustomerRow.cif.CUSTOMER_NAME + '|' + anItem.WB_CustomerRow.cif.CUSTOMER_ID) : ""
                    prodName = (aBO.WB_AffinitySet.bItemHasProductGroup) ? (anItem.WB_ProductGroupRow.cif.PRODUCT_GROUP_NAME + '|' + anItem.WB_ProductGroupRow.cif.PRODUCT_GROUP_ID) : (anItem.WB_ProductRow.cif.PRODUCT_NAME + '|' + anItem.WB_ProductGroupRow.cif.PRODUCT_ID)
                    arrGroup = []
                }

                arrGroup.push(anItem.WB_AffinityGroupRow)
            })
            if (arrGroup.length > 1) {
                sError += (!_.isEmpty(custName) ? custName : '') + (!_.isEmpty(prodName) ? '-' : '') + (!_.isEmpty(prodName) ? prodName : '') + ' in Group' + _.join(_.map(_.uniq(arrGroup), 'AFFINITYGROUP_NAME'), ",")
            }


            if (!_.isEmpty(sError)) {
                sTitle += " can't overlap"
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'Overlap',
                        type: MessageType.Error,
                        title: sTitle,
                        description: sError,
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('Overlap')
            }


            resolve()
        })
    }
}

